const CONFIGURENAME = {
  titleTop: '页面设置',
  navigation: '导航栏',
  mainDrawing: '主图模块',
  product: '产品须知',
  clause: '条款须知',
  guarantee: '保障责任',
  claims: '理赔流程',
  information: '投保信息',
  bottomButton: '底部按钮',
  informationConfirmation: '确认信息',
  trial: '保费试算',
  inform: '健康告知',
  disclosureIcp: '披露页、icp备案号',
  productList: '产品列表',
  queryInfo: '查询记录',
  policyCancel: '退保填写',
  policyDetail: '保单详情',
  invoiceList: '开具发票',
  invoice: '发票填写',
  invoiceRecordList: '开票记录',
  invoiceDetail: '发票详情'
};
const INITAL = {
  //所有页面类型的初始配置
  DETAILS: [{
    //产品信息
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: true,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      }
    }
  }, {
    controlsId: '',
    controlsMark: 'navigation',
    isClick: false,
    style: {
      controlsComponentsMark: 'navigation1',
      fontColor: '#FF6B00',
      fontSize: 14,
      controlsComponentsId: ''
    }
  }, {
    controlsMark: 'mainDrawing',
    isClick: false,
    controlsId: '',
    style: {
      controlsComponentsMark: 'mainDrawing1',
      controlsComponentsId: '',
      productNameColor: '#333',
      productNameFontSize: 14,
      otherFieldsColor: '#989898',
      otherFieldsFontSize: 14,
      controlsLogoDisplay: false,
      //是否展示logo
      controlsLogoExhibitor: 2 //保司 1、中介 2
    }
  }],
  WRITE_PAGE_INFO: [{
    //填写信息页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '填写信息页'
    }
  }],
  CONFIRM_PAGE: [{
    //信息确认
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '信息确认页'
    }
  }],
  TRIAL: [{
    //保费试算
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '保费试算页'
    }
  }],
  INFORM: [{
    //健康告知
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '健康告知页'
    }
  }],
  LANDING_PAGE: [{
    //落地页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '落地页'
    }
  }],
  INFORECORD_PAGE: [{
    //信息记录页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '信息记录页'
    }
  }],
  PRODUCT_LIST_PAGE: [{
    //产品列表页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '产品列表页'
    }
  }],
  QUERY_INFO_PAGE: [{
    //查询记录页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '查询记录页'
    }
  }],
  POLICY_CANCEL_PAGE: [{
    //退保填写页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '退保填写页'
    }
  }],
  POLICY_DETAIL_PAGE: [{
    //保单详情页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '保单详情页'
    }
  }],
  INVOICE_PAGE: [{
    //发票填写页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '发票填写页'
    }
  }],
  INVOICE_LIST_PAGE: [{
    //开具发票页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '开具发票页'
    }
  }],
  INVOICE_RECORD_LIST_PAGE: [{
    //开票记录页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '开票记录页'
    }
  }],
  INVOICE_DETAIL_PAGE: [{
    //发票详情页
    controlsMark: 'titleTop',
    controlsId: '',
    isClick: true,
    style: {
      isDisplayNavigation: false,
      titleColor: '#000',
      backgroundColor: '#fff',
      backgroundImage: '',
      themeColor: '#FF6B00',
      pageDescription: false,
      pageDescriptionConfig: {
        position: 'top',
        content: ''
      },
      pagePopUp: false,
      pagePopUpConfig: {
        popUpPosition: 'bottom',
        buttonName: '',
        buttonEvent: 'close',
        popUpContent: '',
        popUpTitle: '',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00'
      },
      pageTitle: '发票详情页'
    }
  }]
};
const NAVUGATIOBN = {
  controlsId: '',
  controlsMark: 'navigation',
  isClick: false,
  style: {
    controlsComponentsMark: 'navigation1',
    fontColor: '#FF6B00',
    fontSize: 14,
    controlsComponentsId: ''
  }
};
const TITLETOPCOFIGURE = {
  isDisplayNavigation: true,
  titleColor: '#000',
  backgroundColor: '#fff',
  backgroundImage: '',
  themeColor: '#FF6B00',
  pageDescription: false,
  pageDescriptionConfig: {
    position: 'top',
    content: ''
  },
  pagePopUp: false,
  pageTitle: '',
  pagePopUpConfig: {
    popUpPosition: 'bottom',
    buttonName: '',
    buttonEvent: 'close',
    popUpContent: '',
    popUpTitle: '',
    buttonFontColor: '#fff',
    buttonBgColor: '#FF6B00'
  }
};
// 右侧每个配置区所需的字段
const STYLE = {
  navigation: {
    productNameColor: '#333',
    productNameFontSize: 14,
    otherFieldsColor: '#989898',
    otherFieldsFontSize: 14,
    fontColor: '#FF6B00',
    fontSize: 14
  },
  mainDrawing: {
    productNameColor: '#333',
    productNameFontSize: 14,
    otherFieldsColor: '#989898',
    otherFieldsFontSize: 14,
    controlsLogoDisplay: false,
    //是否展示logo
    controlsLogoExhibitor: 1,
    //保司 1、中介 2
    thirdCompanySuffix: undefined //后缀
  },
  product: {
    isHiddenClause: false,
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14,
    clauseColor: '#FF6B00'
  },
  clause: {
    fontColor: '#000',
    fontSize: 14
  },
  guarantee: {
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14
  },
  claims: {
    imgUrl: ''
  },
  information: {
    isIdentification: false,
    isAddInsured: false,
    isHiddenClause: false,
    format: 'pdf',
    limit: 4,
    time: '',
    clauseColor: '#FF6B00',
    insuredNum: 2
  },
  bottomButton: {
    isPremium: false,
    buttonColor: '',
    buttonInfo: [{
      buttonName: '',
      buttonFontColor: '#fff',
      buttonBgColor: '',
      mark: 1,
      buttonPopUp: false,
      controlsJump: undefined,
      buttonPopUpConfig: {
        popUpPosition: 'central',
        //弹窗位置:中部central、底部bottom
        popUpTitle: '',
        //弹窗标题
        popUpContent: '',
        //弹窗内容
        buttonInfo: [
        //按钮配置
        {
          buttonName: '',
          //按钮文案
          buttonFontColor: '#fff',
          //按钮文字颜色
          buttonBgColor: '#FF6B00',
          //按钮颜色
          buttonEvent: '',
          //按钮事件:关闭弹窗close、跳转页面jump
          controlsJump: undefined
        }]
      }
    }]
  },
  informationConfirmation: {
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14
  },
  trial: {
    isIdentification: false,
    color: '#FF6B00'
  },
  inform: {
    fontColor: '#000',
    fontSize: 14
  },
  // 披露页、icp
  disclosureIcp: {
    controlsDisclosurePageDisplay: true,
    //是否展示披露页
    controlsDisclosurePageExhibitor: 2,
    //保司 1、中介 2
    controlsICPDisplay: true,
    //是否展示icp
    controlsICPExhibitor: 2 //保司 1、中介 2
  },
  // 产品列表
  productList: {
    landingPageModuleDisplay: false,
    //是否展示落地页模块
    productListModule: {
      productNameColor: '#000',
      productNameFontSize: 20,
      productButtonBorderColor: '#D7D7D7',
      productButtonBgColor: '#fff',
      otherFieldsColor: '#989898',
      otherFieldsFontSize: 14
      // productListTitleDisplay: true,
      // productListTitle: '请选择投保产品',
    },
    landingPageModule: {
      backgroundImage: '',
      buttonColor: '#FF6B00',
      buttonInfo: [{
        buttonName: '立即投保',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00',
        buttonJumpEvent: 'CLOSE',
        //按钮跳转事件: CLOSE关闭落地页、其它代表跳转页面
        buttonJumpEventConfig: {
          qrConfigId: '',
          //模版组ID
          customerInsuranceId: '',
          insuranceId: ''
        },
        //按钮跳转事件配置
        mark: 1,
        buttonPopUp: false,
        buttonPopUpConfig: {}
      }]
    }
  },
  // 查询记录
  queryInfo: {
    topNavigation: [{
      navigationMark: 'policy',
      //policyDisplay
      navigationLabel: '保单查询',
      //导航名称
      navigationDisplay: true //是否选中
    }, {
      navigationMark: 'order',
      navigationLabel: '订单查询',
      //导航名称
      navigationDisplay: true //是否选中
    }],
    policySearch: {
      //保单查询配置
      searchTerms: [
      //搜索条件配置
      {
        termKey: 'appliMobile',
        //字段库字段标识
        termValue: '手机号查询',
        //字短裤字段名称
        termDisplay: true,
        //是否选中
        sendSMS: false //是否发送短信验证码
      }, {
        termKey: 'policyNo',
        termValue: '保单号查询',
        termDisplay: false
      }, {
        termKey: 'appliCompanyMark',
        termValue: '投保公司自定义标识',
        termDisplay: false
      }],
      buttonInfo: {
        buttonDisplay: false,
        //是否展示按钮
        buttons: [
        //按钮配置
        {
          buttonName: '查看详情',
          //按钮文案
          buttonFontColor: '#fff',
          //按钮文字颜色
          buttonBgColor: '#FF6B00',
          //按钮颜色
          buttonDisplayStatus: [1, 2, 3, 6],
          //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败
          mark: 1,
          //??
          buttonPopUp: false,
          //是否弹窗
          controlsJump: undefined,
          buttonPopUpConfig: {
            //此处为弹框示例不一定会用到
            // popUpPosition: 'central', //弹窗位置:中部central、底部bottom
            // popUpTitle: '', //弹窗标题
            // popUpContent: '' //弹窗内容
            // buttonInfo: [
            //   //按钮配置
            //   {
            //     buttonName: '我要投保', //按钮文案
            //     buttonFontColor: '#fff', //按钮文字颜色
            //     buttonEvent: 'close' //按钮事件:关闭弹窗close、跳转页面jump
            //   }
            // ]
          }
        }, {
          buttonName: '查看电子保单',
          buttonFontColor: '#fff',
          buttonBgColor: '#FF6B00',
          buttonDisplayStatus: [1, 2, 3, 4, 6],
          //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败
          mark: 1,
          buttonPopUp: false,
          buttonPopUpConfig: {}
        }, {
          buttonName: '开具发票',
          buttonFontColor: '#fff',
          buttonBgColor: '#FF6B00',
          buttonDisplayStatus: [1, 2, 3, 6],
          //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败 发票状态：未开票、开票失败；是否可开具发票：可开具发票；
          buttonInvoiceStatus: [],
          //发票按钮可展示状态：未开票 '', 未开票 'UNINVOICED', 开票失败'INVOICED_FAILED', 开票成功'SUCCESS'
          mark: 1,
          buttonPopUp: false,
          buttonPopUpConfig: {}
        }, {
          buttonName: '查看发票',
          buttonFontColor: '#fff',
          buttonBgColor: '#FF6B00',
          buttonDisplayStatus: [1, 2, 3, 6],
          //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败 发票状态：已开票；
          buttonInvoiceStatus: [],
          //发票按钮可展示状态：未开票 'UNINVOICED', 开票失败'INVOICED_FAILED', 开票成功'SUCCESS'
          mark: 1,
          buttonPopUp: false,
          buttonPopUpConfig: {}
        }]
      },
      invoiceInfo: {
        buttonDisplay: false,
        buttons: [{
          buttonName: '开具发票',
          buttonFontColor: '#fff',
          buttonBgColor: '#FF6B00',
          mark: 1,
          buttonPopUp: false,
          buttonPopUpConfig: {},
          idVerity: true //身份验证
        }]
      }
    },
    orderSearch: {
      //订单查询配置
      searchTerms: [
      // 搜索条件配置
      {
        termKey: 'appliMobile',
        // 字段库字段标识
        termValue: '手机号查询',
        // 字短裤字段名称
        termDisplay: true,
        // 是否选中
        sendSMS: false // 是否发送短信验证码
      }, {
        termKey: 'orderNo',
        termValue: '订单号查询',
        termDisplay: false
      }, {
        termKey: 'appliCompanyMark',
        termValue: '投保公司自定义标识',
        termDisplay: false
      }],
      buttonInfo: {
        buttonDisplay: false,
        //是否展示按钮
        buttons: [
        //按钮配置
        {
          buttonName: '继续支付',
          //按钮文案
          buttonFontColor: '#fff',
          //按钮文字颜色
          buttonBgColor: '#FF6B00',
          //按钮颜色
          buttonDisplayStatus: [4, 5],
          //按钮可展示的状态 订单支付状态 1已支付 2已退款 3部分退款 4待支付 5取消支付 6退款失败 7已失效(支付时间已失效需重新发起支付或重新下单)
          mark: 1,
          //??
          buttonPopUp: false,
          //是否弹窗
          buttonPopUpConfig: {}
        }, {
          buttonName: '再次投保',
          buttonFontColor: '#fff',
          buttonBgColor: '#FF6B00',
          buttonDisplayStatus: [7],
          //按钮可展示的状态 订单支付状态 1已支付 2已退款 3部分退款 4待支付 5取消支付 6退款失败 7已失效(支付时间已失效需重新发起支付或重新下单)
          mark: 1,
          buttonPopUp: false,
          buttonPopUpConfig: {}
        }]
      }
    }
  },
  // 退保填写
  policyCancel: {
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14
  },
  // 保单详情
  policyDetail: {
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14,
    policyCancelConfig: {
      policyStatus: [1],
      //可退保状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败
      uncancelableTips: '请联系专属服务团队办理退保业务。' //非可退保单提示文案
    }
  },
  // 开具发票
  invoiceList: {
    invoiceConfig: {
      maxSelect: '' //保单批量勾选数量上限
    },
    buttonInfo: {
      buttonDisplay: true,
      //是否展示按钮
      buttons: [{
        buttonName: '开票记录',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00',
        mark: 1,
        buttonPopUp: false,
        buttonPopUpConfig: {}
      }]
    }
  },
  // 发票填写
  invoice: {
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14,
    invoiceConfig: {
      //发票填写页配置
      invoiceHeadType: ['P', 'C'],
      //纳税人类型: C-一般纳税人 S-小规模纳税人 Q-政府机构/事业单位 P-个人
      invoiceSendMethod: ['email'] //发票接收方式设置 mobile手机号接收 email邮件接收
    }
  },
  // 开票记录
  invoiceRecordList: {
    searchTerms: [
    //搜索条件配置
    {
      termKey: 'mobile',
      termValue: '手机号',
      termDisplay: true
    }, {
      termKey: 'email',
      termValue: '电子邮箱',
      termDisplay: false,
      //是否选中
      sendSMS: false //是否发送短信验证码
    }],
    buttonInfo: {
      //按钮配置
      buttonDisplay: true,
      //是否展示按钮
      buttons: [{
        buttonName: '详情',
        //按钮文案
        buttonFontColor: '#fff',
        //按钮文字颜色
        buttonBgColor: '#FF6B00',
        //按钮颜色
        mark: 1,
        buttonPopUp: false,
        buttonPopUpConfig: {}
      }, {
        buttonName: '查看发票',
        buttonFontColor: '#fff',
        buttonBgColor: '#FF6B00',
        buttonDisplayStatus: ['SUCCESS'],
        //查看发票按钮可展示状态：开票成功； 未开票'', 未开票'UNINVOICED', 开票失败'INVOICED_FAILED', 开票成功'SUCCESS'
        mark: 1,
        buttonPopUp: false,
        buttonPopUpConfig: {}
      }]
    }
  },
  invoiceDetail: {
    fieldColor: '#000',
    fieldFontSize: 14,
    keyColor: '#989898',
    keyFontSize: 14,
    invoiceOffsetConfig: {
      invoiceStatus: ['SUCCESS']
      //发票可作废状态：开票成功； 未开票'', 未开票'UNINVOICED', 开票失败'INVOICED_FAILED', 开票成功'SUCCESS'
    }
  }
};
const COLOR = {
  themeColor: [{
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  backgroundColor: [{
    key: '#fff'
  }],
  productNameColor: [{
    key: '#000'
  }, {
    key: '#fff'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  otherFieldsColor: [{
    key: '#989898'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  titleColor: [{
    key: '#000'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  fieldColor: [{
    key: '#000'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  keyColor: [{
    key: '#989898'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  fontColor: [{
    key: '#000'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  buttonBgColor: [{
    key: '#fff'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  buttonFontColor: [{
    key: '#fff'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  productButtonBorderColor: [{
    key: '#000'
  }, {
    key: '#D7D7D7'
  }, {
    key: '#fff'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }],
  productButtonBgColor: [{
    key: '#fff'
  }, {
    key: '#FF6B00'
  }, {
    key: '#11B984'
  }, {
    key: '#007FFF'
  }]
};
export { CONFIGURENAME, INITAL, NAVUGATIOBN, STYLE, TITLETOPCOFIGURE, COLOR };